import React from 'react';

import {
  Title,
  Grid,
  GridRow,
  GridItem,
  Root,
} from '../style';

function Decline() {
  return (
    <Root>
      <Title>Отказ</Title>
      <Grid>
        <GridRow>
          <GridItem label>
            Решение:
          </GridItem>
          <GridItem>
            Отказать
          </GridItem>
        </GridRow>
      </Grid>
    </Root>
  );
}

export default Decline;
